<template>
  <section :class="['px-0!', backgroundClasses]">
    <div class="h-pad">
      <CTABlock
        :button="content.buttons?.length ? content.buttons[0] : null"
        :description="content.description"
        :subtitle="content.subtitle"
        :title="content.title"
      />
    </div>
    <div v-reveal>
      <ImagesCarousel
        :dark="content.background === 'burgundy'"
        :images="content.items"
        class="mt-10 md:mt-15 transition-[margin]"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import CTABlock from '@/components/blocks/CTABlock.vue'
import ImagesCarousel from '@/components/blocks/ImagesCarousel.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'CarouselSection',
  components: { CTABlock, ImagesCarousel },
  props: {
    content: {
      type: Object as PropType<CarouselSection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
}
</script>
